<template>
  <v-container fluid class="bg-image pt-0 pb-0">
    <v-row v-if="isLoggedIn" class="mx-3 py-2" align="center">
      <v-btn text color="white" @click="changeLang('en')">EN</v-btn>
      <p class="my-0 mt-1 white--text">|</p>
      <v-btn text color="white" @click="changeLang('fr')">FR</v-btn>
      <v-spacer></v-spacer>
      <p
        class="my-0 mr-3 subtitle-1 font-weight-light appYellow--text text-uppercase"
      >{{vg_user.first_name}} {{vg_user.last_name}}</p>
      <p class="my-0 white--text">|</p>
      <v-btn text color="white" class="font-weight-regular" @click="logout">{{$t('logout')}}</v-btn>
    </v-row>
    <v-row v-else class="mx-3 py-2">
      <v-btn text color="white" @click="changeLang('en')">EN</v-btn>
      <p class="my-0 mt-1 white--text">|</p>
      <v-btn text color="white" @click="changeLang('fr')">FR</v-btn>
      <v-spacer></v-spacer>
      <v-btn text color="white" @click="handleLoginClick">{{$t('login')}}</v-btn>
      <p class="my-0 mt-1 white--text">|</p>
      <v-btn text color="white" to="/register">{{$t('register')}}</v-btn>
    </v-row>
    <v-row justify="center">
      <v-img
        class="my-0 mb-3"
        :src="imageLogoUrlWhite"
        :max-height="imageHeight"
        contain
        aspect-ratio="1.7"
      ></v-img>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  methods: {
    ...mapMutations({
      setUser: 'Auth/SET_USER'
    }),
    logout () {
      this.setUser(null)
      this.$router.push('/login')
      return this.$snackbar({ text: 'Logged out successfully.', color: 'success', timeout: 5000 })
    },
    handleLoginClick () {
      this.$router.push({ path: '/login', query: { redirect: this.$route.fullPath } })
    }
  },
  computed: {
    ...mapGetters({
      vg_user: 'Auth/user'
    }),
    imageHeight () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '100px'
        case 'sm': return '150px'
        case 'md': return '150px'
        case 'lg': return '150px'
        case 'xl': return '250px'
        default: return '150px'
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.bg-image {
  background: linear-gradient(
      0deg,
      rgba(2, 16, 48, 0.25),
      rgba(2, 16, 48, 0.25)
    ),
    url("../assets/images/Stock/background-image.jpg");
  /* Background image is centered vertically and horizontally at all times */
  background-position: center;

  /* Background image doesn't tile */
  background-repeat: no-repeat;

  /* Background image is fixed in the viewport so that it doesn't move when
     the content's height is greater than the image's height */
  // GETTING RID OF THE FIXED HELPED GET RID OF THE COVERNESS/ZOOMED IN IMAGE

  // background-attachment: fixed;

  /* This is what makes the background image rescale based
     on the container's size */
  background-size: cover;

  /* Set a background color that will be displayed
     while the background image is loading */
}
</style>
